// Import all sample files as raw text
import sample01 from '../../samples/01-zero-width-space.txt?raw';
import sample02 from '../../samples/02-zero-width-non-joiner.txt?raw';
import sample03 from '../../samples/03-zero-width-joiner.txt?raw';
import sample04 from '../../samples/04-word-joiner.txt?raw';
import sample05 from '../../samples/05-soft-hyphen.txt?raw';
import sample06 from '../../samples/06-bidi-override.txt?raw';
import sample07 from '../../samples/07-other-invisible-chars.txt?raw';
import sample08 from '../../samples/08-homoglyph-confusables.txt?raw';
import sample09 from '../../samples/09-script-mixing.txt?raw';
import sample10 from '../../samples/10-normalization-instability.txt?raw';
import sample11 from '../../samples/11-repeating-invisible-pattern.txt?raw';
import sample12 from '../../samples/12-positional-pattern.txt?raw';
import sample13 from '../../samples/13-diacritics-abuse.txt?raw';
import sample14 from '../../samples/14-format-character-abuse.txt?raw';
import sample15 from '../../samples/15-semantic-context.txt?raw';
import sample16 from '../../samples/16-url-confusables.txt?raw';
import sample17 from '../../samples/17-bidi-exploits.txt?raw';
import sample18 from '../../samples/18-zero-width-chains.txt?raw';
import sample19 from '../../samples/19-language-specific.txt?raw';
import sample20 from '../../samples/20-math-symbol-substitution.txt?raw';
import sample21 from '../../samples/21-control-character-exploits.txt?raw';
import sample22 from '../../samples/22-whitespace-abuse.txt?raw';
import sample23 from '../../samples/23-character-width-anomaly.txt?raw';
import sample24 from '../../samples/24-lookalike-digits.txt?raw';
import sample25 from '../../samples/25-quotation-confusion.txt?raw';
import sample26 from '../../samples/26-frequency-anomaly.txt?raw';
import sample27 from '../../samples/27-domain-specific.txt?raw';
import sample28 from '../../samples/28-length-manipulation.txt?raw';
import sample29 from '../../samples/29-pua-detection.txt?raw';
import sample30 from '../../samples/30-fullwidth-exploitation.txt?raw';
import sample31 from '../../samples/31-tag-block-smuggling.txt?raw';
import sample32 from '../../samples/32-emoji-token-expansion.txt?raw';
import sample33 from '../../samples/33-llm-gpt4-jailbreak.txt?raw';
import sample34 from '../../samples/34-combined-bidi-homoglyph.txt?raw';
import sample35 from '../../samples/35-combined-steganography-normalization.txt?raw';
import sample36 from '../../samples/36-ntfs-ads-exploitation.txt?raw';
import sample38 from '../../samples/38-grapheme-cluster-abuse.txt?raw';
import sample39 from '../../samples/39-rtl-shaping-attack.txt?raw';
import sample40 from '../../samples/40-variation-selector-steganography.txt?raw';
import sample41 from '../../samples/41-minimal-rtl-phishing.txt?raw';

export interface SampleFile {
  id: string;
  testNumber: number;
  title: string;
  content: string;
}

export const samples: Record<string, SampleFile> = {
  'zero-width-space': {
    id: 'zero-width-space',
    testNumber: 1,
    title: 'Zero-Width Space Detection',
    content: sample01
  },
  'zero-width-non-joiner': {
    id: 'zero-width-non-joiner',
    testNumber: 2,
    title: 'Zero-Width Non-Joiner Detection',
    content: sample02
  },
  'zero-width-joiner': {
    id: 'zero-width-joiner',
    testNumber: 3,
    title: 'Zero-Width Joiner Detection',
    content: sample03
  },
  'word-joiner': {
    id: 'word-joiner',
    testNumber: 4,
    title: 'Word Joiner Detection',
    content: sample04
  },
  'soft-hyphen': {
    id: 'soft-hyphen',
    testNumber: 5,
    title: 'Soft Hyphen Detection',
    content: sample05
  },
  'bidi-override': {
    id: 'bidi-override',
    testNumber: 6,
    title: 'Bidirectional Override Detection',
    content: sample06
  },
  'other-invisible': {
    id: 'other-invisible',
    testNumber: 7,
    title: 'Other Invisible Characters Detection',
    content: sample07
  },
  'homoglyph-confusables': {
    id: 'homoglyph-confusables',
    testNumber: 8,
    title: 'Homoglyph & Confusable Characters Detection',
    content: sample08
  },
  'script-mixing': {
    id: 'script-mixing',
    testNumber: 9,
    title: 'Language Script Mixing Detection',
    content: sample09
  },
  'normalization-instability': {
    id: 'normalization-instability',
    testNumber: 10,
    title: 'Unicode Normalization Instability Detection',
    content: sample10
  },
  'repeating-pattern': {
    id: 'repeating-pattern',
    testNumber: 11,
    title: 'Repeating Invisible Character Pattern Detection',
    content: sample11
  },
  'positional-pattern': {
    id: 'positional-pattern',
    testNumber: 12,
    title: 'Positional Distribution Pattern Detection',
    content: sample12
  },
  'diacritics-abuse': {
    id: 'diacritics-abuse',
    testNumber: 13,
    title: 'Combining Diacritics Abuse Detection',
    content: sample13
  },
  'format-character-abuse': {
    id: 'format-character-abuse',
    testNumber: 14,
    title: 'Format Character Abuse Detection',
    content: sample14
  },
  'semantic-context': {
    id: 'semantic-context',
    testNumber: 15,
    title: 'Semantic Context Analysis Detection',
    content: sample15
  },
  'url-confusables': {
    id: 'url-confusables',
    testNumber: 16,
    title: 'URL/Domain Confusables Detection',
    content: sample16
  },
  'bidi-exploits': {
    id: 'bidi-exploits',
    testNumber: 17,
    title: 'Bidirectional Text Exploits Detection',
    content: sample17
  },
  'zero-width-chains': {
    id: 'zero-width-chains',
    testNumber: 18,
    title: 'Zero-Width Character Chains Detection',
    content: sample18
  },
  'language-specific': {
    id: 'language-specific',
    testNumber: 19,
    title: 'Language-Specific Attacks Detection',
    content: sample19
  },
  'math-symbol-substitution': {
    id: 'math-symbol-substitution',
    testNumber: 20,
    title: 'Mathematical Symbol Substitution Detection',
    content: sample20
  },
  'control-character-exploits': {
    id: 'control-character-exploits',
    testNumber: 21,
    title: 'Control Character Exploits Detection',
    content: sample21
  },
  'whitespace-abuse': {
    id: 'whitespace-abuse',
    testNumber: 22,
    title: 'Whitespace Abuse & Manipulation Detection',
    content: sample22
  },
  'character-width-anomaly': {
    id: 'character-width-anomaly',
    testNumber: 23,
    title: 'Character Width Anomalies Detection',
    content: sample23
  },
  'lookalike-digits': {
    id: 'lookalike-digits',
    testNumber: 24,
    title: 'Look-alike Digits & Numbers Detection',
    content: sample24
  },
  'quotation-confusion': {
    id: 'quotation-confusion',
    testNumber: 25,
    title: 'Quotation Mark Confusion Detection',
    content: sample25
  },
  'frequency-anomaly': {
    id: 'frequency-anomaly',
    testNumber: 26,
    title: 'Frequency Analysis & Anomaly Detection',
    content: sample26
  },
  'domain-specific': {
    id: 'domain-specific',
    testNumber: 27,
    title: 'Domain-Specific Pattern Detection',
    content: sample27
  },
  'length-manipulation': {
    id: 'length-manipulation',
    testNumber: 28,
    title: 'String Length Manipulation Detection',
    content: sample28
  },
  'pua-detection': {
    id: 'pua-detection',
    testNumber: 29,
    title: 'PUA (Private Use Area) Detection',
    content: sample29
  },
  'fullwidth-exploitation': {
    id: 'fullwidth-exploitation',
    testNumber: 30,
    title: 'Fullwidth Character Exploitation',
    content: sample30
  },
  'tag-block-smuggling': {
    id: 'tag-block-smuggling',
    testNumber: 31,
    title: 'Tag Block Smuggling Detection',
    content: sample31
  },
  'emoji-token-expansion': {
    id: 'emoji-token-expansion',
    testNumber: 32,
    title: 'Emoji Token Expansion Detection',
    content: sample32
  },
  'llm-gpt4-jailbreak': {
    id: 'llm-gpt4-jailbreak',
    testNumber: 33,
    title: 'LLM GPT-4 Jailbreak Detection',
    content: sample33
  },
  'combined-bidi-homoglyph': {
    id: 'combined-bidi-homoglyph',
    testNumber: 34,
    title: 'Combined Bidirectional & Homoglyph Detection',
    content: sample34
  },
  'combined-steganography-normalization': {
    id: 'combined-steganography-normalization',
    testNumber: 35,
    title: 'Combined Steganography & Normalization Detection',
    content: sample35
  },
  'ntfs-ads-exploitation': {
    id: 'ntfs-ads-exploitation',
    testNumber: 36,
    title: 'NTFS ADS Exploitation Detection',
    content: sample36
  },
  'grapheme-cluster-abuse': {
    id: 'grapheme-cluster-abuse',
    testNumber: 38,
    title: 'Grapheme Cluster Abuse Detection',
    content: sample38
  },
  'rtl-shaping-attack': {
    id: 'rtl-shaping-attack',
    testNumber: 39,
    title: 'RTL Shaping Attack Detection',
    content: sample39
  },
  'variation-selector-steganography': {
    id: 'variation-selector-steganography',
    testNumber: 40,
    title: 'Variation Selector Steganography Detection',
    content: sample40
  },
  'minimal-rtl-phishing': {
    id: 'minimal-rtl-phishing',
    testNumber: 41,
    title: 'Minimal RTL Phishing Detection',
    content: sample41
  }
};

// Helper function to get sample by test number
export const getSampleByTestNumber = (testNumber: number): SampleFile | undefined => {
  return Object.values(samples).find(sample => sample.testNumber === testNumber);
};

// Helper function to get sample by ID
export const getSampleById = (id: string): SampleFile | undefined => {
  return samples[id];
};

